import { styled } from '@lichtblick/styled';
import { Colors } from '@lichtblick/theme';

export const Container = styled.div`
  align-items: center;
  align-self: stretch;
  background: ${Colors.white};
  border: 1px solid ${Colors.blue[20]};
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 3rem 2rem;
  width: 100%;
`;

export const TextContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
